import axios from "axios";
import {
  appendAuthInterceptor,
  requestWrapper,
} from "../../../Common/serviceFactory";
import { recommendedBy } from "../../referees/Constants";

import {
  getAllInstitutions,
  getAllCountries,
  GetContactTitles,
} from "../../../Common/publicService";

const PROPOSAL_FILES_BASE_URL = "registration/Proposal docs";

const axiosAdvisorInstance = axios.create({
  baseURL: `${process.env.REACT_APP_REQUEST_ADVISOR}`,
});

const axiosCMSInstance = axios.create({
  baseURL: process.env.REACT_APP_CMS_REQUEST_BASE_URL,
});

const axiosFilesInstance = axios.create({
  baseURL: `${process.env.REACT_APP_REQUEST_ADVISOR_FILES}`,
});

appendAuthInterceptor(axiosAdvisorInstance);
appendAuthInterceptor(axiosFilesInstance);

const service = {
  getAllInstitutions,
  getAllCountries,
  GetContactTitles,
  async  createProposalRefreeByContact(props) {
    const { proposalId, contact, recommendedBy } = props;
    return await requestWrapper(
      axiosAdvisorInstance.post(
        `/proposal/proposalreferee/${proposalId}/${recommendedBy}/create`,
        contact
      )
    );
  },
  async GetAdvisorId() {
    return await requestWrapper(axiosAdvisorInstance.get(`/advisor/id`));
  },
  async GetContats(filter) {
    return await requestWrapper(
      axiosAdvisorInstance.get(`/referee/find?sw=${filter}`)
    );
  },
  async GetAdvisorCommittees() {
    return await requestWrapper(
      axiosAdvisorInstance.get(`/advisor/committees`)
    );
  },
  async GetCommitteeAdvisors(props) {
    const { committeeId } = props;
    return await requestWrapper(
      axiosAdvisorInstance.get(`/committee/${committeeId}/advisors`)
    );
  },
  async GetCommitteeProposals(props) {
    const { committeeId } = props;
    return await requestWrapper(
      axiosAdvisorInstance.get(`/committee/${committeeId}/proposals`)
    );
  },
  async GetCommitteePreProposals(props) {
    const { committeeId } = props;
    return await requestWrapper(
      axiosAdvisorInstance.get(`/committee/${committeeId}/preproposals`)
    );
  },
  async AssotiateAdvisorToProposal(props) {
    const { advisorId, proposalId, committeeId } = props;
    return await requestWrapper(
      axiosAdvisorInstance.post(
        `/advisor/${advisorId}/assign/${proposalId}/${committeeId}`
      )
    );
  },
  async AssotiateMeToProposal(props) {
    const { proposalId, committeeId } = props;
    return await requestWrapper(
      axiosAdvisorInstance.post(`/advisor/assign/${proposalId}/${committeeId}`)
    );
  },
  async UpdateAdvisorRanking(props) {
    const { proposalAdvisorId, comment, rank, grade, isFinal } = props;
    return await requestWrapper(
      axiosAdvisorInstance.post(
        `/advisor/${proposalAdvisorId}/rank/update`,
        JSON.stringify({ comment, rank, grade, isFinal }),
        { headers: { "Content-Type": "application/json" } }
      )
    );
  },
  async UpdatePanelRanking(props) {
    const { proposalId, justification, rank, grade, isfinal } = props;
    return await requestWrapper(
      axiosAdvisorInstance.post(
        `/proposal/${proposalId}/rank/update`,
        JSON.stringify({ justification, rank, grade, isfinal }),
        { headers: { "Content-Type": "application/json" } }
      )
    );
  },
  async UpdatePreProposalCCDecision(props) {
    const { proposalId, decision, decisionReason} = props;
    return await requestWrapper(
      axiosAdvisorInstance.post(
        `/proposal/${proposalId}/decision/update`,
        JSON.stringify({ decision, decisionReason}),
        { headers: { "Content-Type": "application/json" } }
      )
    );
  },
  async registerReferee(request) {
    return await requestWrapper(
      axiosCMSInstance.post(`api/account/referee/register`, request)
    );
  },
  async CreateProposalReferee(props) {
    const { proposalId, contactId } = props;
    const recomendedBy = recommendedBy.Advisor;
    return await requestWrapper(
      axiosAdvisorInstance.post(
        `/referee/create/${proposalId}/${contactId}/${recomendedBy}`
      )
    );
  },
  async GetProposalRefereeById(props) {
    const { proposalRefereeId } = props;
    return await requestWrapper(
      axiosAdvisorInstance.get(`/referee/${proposalRefereeId}/proposalreferee`)
    );
  },
  async GetNumberOfProposalAdvisor(props) {
    const { advisorId, committeeId } = props;
    return await requestWrapper(
      axiosAdvisorInstance.get(
        `/advisor/${advisorId}/${committeeId}/proposalnumber`
      )
    );
  },
  async GetProposalRefereeForProposal(props) {
    const { proposalId } = props;
    return await requestWrapper(
      axiosAdvisorInstance.get(`/proposal/${proposalId}/referees`)
    );
  },
  async getProposalFiles(props) {
    const { proposalId } = props;
    return await requestWrapper(
      axiosFilesInstance.get(
        `files/?path=${PROPOSAL_FILES_BASE_URL}/${proposalId}`
      )
    );
  },
  async MarkInterestsConflict(props) {
    const { proposalAdvisorId } = props;
    return await requestWrapper(
      axiosAdvisorInstance.post(
        `/advisor/${proposalAdvisorId}/conflict`
      )
    );
  },
  async downloadProposalFiles(props) {
    const { id, fileName } = props;
    const filePath = `files/${PROPOSAL_FILES_BASE_URL}/${id}/${id}_${fileName}`;
    return await requestWrapper(
      axiosFilesInstance.get(filePath, {
        params: {
          cacheBustTimestamp: Date.now(), // prevents IE cache problems on re-download
        },
        responseType: "blob",
        headers: {
          Accept: "application/octet-stream",
        },
      })
    );
  },
  async UploadContactImage(props) {
    const { file, contactId } = props;
    var formData = new FormData();
    formData.append("document1", file);
    return await requestWrapper(
      axiosAdvisorInstance.post(`contact/${contactId}/image/add`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    );
  },
  async GetContactsImages(props) {
    const { contactsIds } = props;
    return await requestWrapper(
      axiosAdvisorInstance.post(
        `/contact/images`,
        JSON.stringify(contactsIds),
        { headers: { "Content-Type": "application/json" } }
      )
    );
  },
  async createProposalPDF({ proposalId }) {
    return await requestWrapper(
      axiosAdvisorInstance.get(`/proposal/${proposalId}/GeneratePDF`, {
        params: {
          idType: "ProposalId",
          header: "",
        },
      })
    );
  },
  async downloadRawFile({ path, filename }) {
    const response = await requestWrapper(
      axiosFilesInstance.get(`files/${path}`, {
        params: {
          cacheBustTimestamp: Date.now(), // prevents IE cache problems on re-download
        },
        responseType: "blob",
        headers: {
          Accept: "application/octet-stream",
        },
      })
    );
    if (!(response instanceof Blob)) {
      return;
    }

    const blob = new Blob([response], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  },
};

export default service;
